module.exports = __webpack_public_path__ + "static/img/thumb_20.6b4ec5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_20.jpg
// module id = 0VLl
// module chunks = 0